import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './Base/login/login.component';
import { HomeComponent } from './Base/home/home.component';
import { RiderDetailsComponent } from './Module/RiderDetails/rider-details/rider-details.component';
import { ShippingManagerComponent } from './Module/Shipping/shipping-manager/shipping-manager.component';
import { RiderOrdersComponent } from './Module/Reports/rider-orders/rider-orders.component';
import { RiderAccountsComponent } from './Module/Reports/rider-accounts/rider-accounts.component';
import { TripsComponent } from './Module/Reports/trips/trips.component';
import { RatingsComponent } from './Module/Reports/ratings/ratings.component';
import { DashboardComponent } from './Module/RiderDetails/dashboard/dashboard.component';
import { PreAppAndroidComponent } from './Module/pre-app-android/pre-app-android.component';
import { NotAuthorizedComponent } from './Base/not-authorized/not-authorized.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: "rider-details",
    component: RiderDetailsComponent,
  },
  {
    path: "dashboard",
    component: DashboardComponent,
  },
  {
    path: "shipping-details",
    component: ShippingManagerComponent,
  },
  {
    path: "rider-orders",
    component: RiderOrdersComponent,
  },
  {
    path: "rider-accounts",
    component: RiderAccountsComponent,
  },
  {
    path: "trips",
    component: TripsComponent,
  },
  {
    path: "ratings",
    component: RatingsComponent,
  },
  {
    path: "pre-app-and",
    component: PreAppAndroidComponent,
  },
    {
    path: 'unauthorized',
    component: NotAuthorizedComponent
  }
  ,
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
